import { Select } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BusinessTypeSelectorProps {
  onChange: (value: 'followAndWatch' | 'followed' | 'watched') => void;
}

function BusinessTypeSelectorComponent({ onChange }: BusinessTypeSelectorProps) {
  const { t } = useTranslation('businessManagement');
  const BusinessTypeFilter: Record<string, { value: 'followAndWatch' | 'followed' | 'watched'; label: string }> = {
    FOLLOWED_OPEN: {
      value: 'followed',
      label: t('businessTypeFilter.followed'),
    },
    WATCHED_OPEN: {
      value: 'watched',
      label: t('businessTypeFilter.watched'),
    },
    FOLLOWED_WATCHED_OPEN: {
      value: 'followAndWatch',
      label: t('businessTypeFilter.followAndWatch'),
    },
  };
  const [value, setValue] = React.useState(BusinessTypeFilter.FOLLOWED_WATCHED_OPEN);

  React.useEffect(() => {
    onChange(value.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Select
      onChange={
        /* istanbul ignore next */ (e) => {
          const a =
            Object.entries(BusinessTypeFilter).find(([, val]) => val.value === e.target.value)?.[0] || 'FOLLOWED_WATCHED_OPEN';
          setValue(BusinessTypeFilter[a]);
        }
      }
      bg="blue.500"
      color="#fff"
      borderColor="blue.500"
      maxW="250px"
      mr={5}
      size="sm"
      borderRadius="md"
      fontSize="sm"
      fontWeight="bold"
      data-testid="filterLocationBtn"
      value={value.value}
    >
      {Object.values(BusinessTypeFilter).map((option) => {
        return (
          <option value={option.value} key={option.value} style={{ color: '#000' }}>
            {option.label}
          </option>
        );
      })}
    </Select>
  );
}

export const BusinessTypeSelector = React.memo(BusinessTypeSelectorComponent);
